<template>
  <v-row class="flex-column mt-6 pr-8">
    <v-col class="custom-panel">
      <v-row class="flex-column">
        <v-col class="custom-panel__header">
          Add Tier
          <v-btn icon @click="$router.push('/tiers')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-col>
        <v-form v-model="valid" class="form-right-view-lable">
          <v-col class="custom-form mt-5">
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Tier Name *</label></v-col
              >
              <v-col sm="8">
                <v-text-field
                  v-model="tierName"
                  :rules="nameRules"
                  filled
                  autofocus
                />
                 <font color="red" class="v-virtual-table">{{ text }}</font>
              </v-col>
              <v-col sm="1">
                <v-checkbox
                  class="custom-form__label ml-9 pl-9"
                  label="Custom Tier"
                  v-model="isCustom"
                  v-on:change="onChecked()"
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row no-gutters v-if="isCustom" >
              <v-col sm="2">
                <label class="custom-form__label">Select Customer</label>
              </v-col>
              <v-col sm="8">
                <v-autocomplete v-model="selectedCustomer" :item-text="(item) => item.name" :items="CustomersList" :item-value="(item) => item.id" dense
             filled :rules="SelectCustomer">
                  
                </v-autocomplete>
              </v-col>
              <!-- <font color="red" class="v-virtual-table">{{ text }}</font> -->
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Description *</label></v-col
              >
              <v-col sm="8">
                <v-text-field
                  v-model="tierDescription"
                  :rules="descriptionRules"
                  filled
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Tools Integration *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="toolsIntegration"
                  :items="toolsData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Refresh Rate *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="refreshRate"
                  :items="refreshData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Type</label>
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="refreshRateTypeData"
                  :items="refreshRateType"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Space *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="space"
                  :items="spaceData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Units</label>
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="spaceTypeData"
                  :items="spaceType"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Data Archive *</label>
              </v-col>
              <v-col sm="4">
                <v-select
                  v-model="dataArchive"
                  :items="archiveData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9"
                  >Archive Duration</label
                >
              </v-col>
              <v-col sm="2">
                <v-select
                  v-model="archiveDataType"
                  :items="archiveTypeDuration"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label">Duration *</label></v-col
              >
              <v-col sm="4">
                <v-select
                  v-model="tierDays"
                  :rules="daysRules"
                  :items="durationData"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                />
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9"
                  >Duration Type</label
                ></v-col
              >
              <v-col sm="2">
                <v-select
                  v-model="durationDefault"
                  :items="durationType"
                  :item-value="(item) => item.value"
                  append-icon="expand_more"
                  attach
                ></v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col sm="2"
                ><label class="custom-form__label mt-1"
                  >Products Included *</label
                ></v-col
              >
              <v-col sm="8">
                <v-checkbox
                  v-for="(product, i) in tiersList"
                  :key="i"
                  v-model="product.check"
                  :label="product.productName"
                  >{{ product.productName }}
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row v-for="(product, i) in tiersList" :key="i" no-gutters>
              <v-col v-if="product.check" sm="2"
                ><label
                  class="custom-form__label"
                  filled
                  :label="product.productName"
                  ># of users in {{ product.productName }} *
                </label></v-col
              >
              <v-col v-if="product.check" sm="1">
                <v-text-field
                  v-model="product.noOfUsers"
                  :rules="NoOfUsers"
                  filled
                />
              </v-col>
              <v-col v-if="product.check" offset-sm="1" sm="2">
                <label
                  class="custom-form__label"
                  filled
                  :label="product.productName"
                  >License Cost per user
                </label>
              </v-col>
              <v-col v-if="product.check" sm="1">
                <v-text-field
                  v-model="product.licenseFee"
                  :rules="licenseFee"
                  filled
                />
              </v-col>
            </v-row>
          
            <v-row no-gutters>
              <v-col sm="2">
                <label class="custom-form__label">Number Of Test Execution Cycles</label>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model="noOfTestExec"
                   @keydown="updated($event)"
                   @keypress="isNumber($event)"
                />
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Number Of Devices</label>
              </v-col>
              <v-col sm="1">
                <v-text-field
                v-model="noOfDevices"
                 @keydown="updated($event)"
                  @keypress="isNumber($event)"
                />
              </v-col>
              <v-col sm="2">
                <label class="custom-form__label ml-9 pl-9">Number Of Labs</label>
              </v-col>
              <v-col sm="1">
                <v-text-field
                  v-model="noOfLabs"
                   @keydown="updated($event)"
                   @keypress="isNumber($event)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  :disabled="!valid || buttonCheck()"
                  class="primary_btn small"
                  depressed
                  @click="createTierData"
                  >Create</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeActions } from '@/store/actions.constants';

export default {
  data() {
    return {
      selectedCustomer:null,
      searchTerm:null,
      isCustom:0,
      valid: false,
      check: false,
      items: [],
      tierName: '',
      tierData: [],
      invalidChars: ['-', '+', 'e', '.'],
      tierDescription: '',
      selectedProducts: [],
      numberOfTedUsers: '',
      costForTedUser: '',
      numberOfPaceUsers: '',
      costForPaceUser: '',
      numberOfMobeUsers: '',
      costForMobeUser: '',
      noOfDevices:0,
      noOfLabs:0,
      noOfTestExec:0,
      CustomersList:[],
      tierObj: {},
      tierDays: null,
      durationData: ['15', '1'],
      toolsData: ['1-5', '6-10', 'Unlimited'],
      refreshData: ['5', '10', 'Unlimited'],
      refreshRateTypeData: 'week',
      refreshRateType: ['days', 'week', 'month'],
      spaceData: ['250', '500', '1'],
      spaceTypeData: 'GB',
      spaceType: ['GB', 'TB'],
      archiveData: ['30', '60', '90', '120'],
      archiveDataType: 'days',
      archiveTypeDuration: ['days','weeks', 'months', 'year'],
      toolsIntegration: '',
      refreshRate: '',
      space: '',
      dataArchive: null,
      durationDefault: 'year',
      durationType: ['days', 'year'],
      nameRules: [
        (v) => !!v?.trim() || 'Tier Name is required',
        (v) =>
          /^[A-Za-z_ ]{3,20}$/.test(v?.trim()) ||
          'Name should contain character only and length should be 3 to 20',
      ],
      daysRules: [
        (v) => !!v || 'Duration required in number of days.',
        (v) => /^[\d]*$/.test(v) || 'Only positive numbers are allowed.',
        (v) => (v > 0 && v <= 365) || 'Number of days must be 1 to 365.',
      ],
      NoOfUsers: [
        (v) => !!v || 'No. of users required',
        (v) => /^[\d]*$/.test(v) || 'Only positive numbers are allowed.',
        (v) => v > 0 || 'Only positive numbers are allowed.',
      ],
      SelectCustomer: [
        (v) => !!v || 'Customer is required',
      ],
      licenseFee: [
        // (v) => !!v || 'License fee required',   //Since we sholud able to create license with default 0 price
        (v) =>
          /^(\$|)([0-9]\d{0,2}(\,\d{3})*|([0-9]\d*))(\.\d{2})?$/.test(v) ||
          'Invalid Price',
        (v) => v >= 0 || 'Only positive numbers are allowed.',
      ],
      descriptionRules: [
        (val) => !!val.trim() || 'Description is required.',
        (val) =>
          val.trim().length <= 100 ||
          'Description should not be more than 100 character.',
      ],
      text: '',
      check: false,
    };
  },
  computed: {
    ...mapGetters({
      tiersData: 'tiers/getTier',
     //getCustomersList: 'tiers/getCustomerList'
    }),
    tiersList() {
      return this.selectedProducts;
    },
  },
  async mounted() {
    // let response = await this.getListOfCustomers();
    // this.CustomersList = response.data;
    let products = await this.getProducts();
    let res = await this.getListOfCustomers();
    this.CustomersList = res.data;
    //console.log("gte",this.CustomersList)
    this.selectedProducts = products.data.map(({ id, productName }) => ({
      productId: id,
      productName,
      noOfUsers: 0,
      licenseFee: 0,
    }));
  },

  methods: {
    ...mapActions({
      createTier: 'tiers/addTiers',
      getTierById: 'licensees/getTierById',
      getTierList: 'tiers/getTierList',
      getProducts: 'tiers/getProductList',
      getListOfCustomers:'tiers/getListOfCustomers'
    }),
    async getProductData() {
      console.log('ProductData', this.tierData.data);
    },
    onChecked(){
     if(!this.isCustom)
     this.selectedCustomer="";
     //console.log("select",this.selectedCustomer);
    },
    updated(val) {
      if (this.invalidChars.includes(val.key)) val.preventDefault();
    },
    buttonCheck() {
      if (
        this.tierName == null ||this.isCustom==1&&this.selectedCustomer==''||
        this.tierName === '' ||
        this.tierDescription == null ||
        this.tierDescription === '' ||
        this.tierDays === null ||
        this.toolsIntegration === '' ||
        this.refreshRate === null ||
        this.space === null ||
        this.dataArchive === null ||
        this.tiersList.filter((el) => el.check === true).length === 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    async createTierData() {
      if (this.toolsIntegration === 'Unlimited') {
        this.toolsIntegration = -1;
      }
      if (this.refreshRate === 'Unlimited') {
        this.refreshRate = -1;
      }
      if (this.dataArchive === 'Unlimited') {
        this.dataArchive = -1;
      }
      if (this.toolsIntegration === '1-5') {
        this.toolsIntegration = 5;
      } else if (this.toolsIntegration === '1-6') {
        this.toolsIntegration = 10;
      }
      //console.log("valuwdghjshhdjsj",this.tiersList.filter((el) => el.check === true));
      this.tierObj = await this.createTier({
        tierName: this.tierName,
        description: this.tierDescription,
        days: this.tierDays,
        noOfTools: this.toolsIntegration,
        refreshRate: this.refreshRate,
        refreshRateType: this.refreshRateTypeData,
        space: this.space,
        spaceType: this.spaceTypeData,
        dataArchive: this.dataArchive,
        dataArchiveType: this.archiveDataType,
        durationType: this.durationDefault,
        products: this.tiersList.filter((el) => el.check === true),
        noOfDevices:parseInt(this.noOfDevices),
        noOfLabs:parseInt(this.noOfLabs),
        noOfTestExec:parseInt(this.noOfTestExec),
        isCustom:this.isCustom,
        customerId:this.selectedCustomer,
      });
      if (this.tierObj.status === 200) {
        this.$router.push('/tiers');

        this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
          text: 'Tier Created Successfully',
          timeout: 1000,
          color: 'success',
        });
      } else {
        this.text = this.tierObj.data.message;
      }
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
  },
};
</script>
